import React, { ReactNode } from 'react';
import './StatusBadge.scss';

export type BadgeVariant = 
  | 'assincrono' 
  | 'blended' 
  | 'default'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'primary'
  | 'secondary';

export type BadgeSize = 'small' | 'medium' | 'large';

export interface StatusBadgeProps { 
  variant?: BadgeVariant; 
  size?: BadgeSize; 
  children: ReactNode; 
  htmlContent?: string; 
  className?: string; 
  icon?: ReactNode; 
  rounded?: boolean; 
  outline?: boolean; 
  minimal?: boolean; // novo: badge minimalista igual ao da imagem
  badgeColor?: string; // cor de fundo customizada
  fontColor?: string; // cor da fonte customizada
  [key: string]: any;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  variant = 'default',
  size = 'medium',
  children,
  htmlContent,
  className = '',
  icon,
  rounded = true,
  outline = false,
  minimal = false, // novo
  badgeColor,
  fontColor,
  ...props
}) => {
  const badgeClasses = [
    'status-badge',
    variant && `status-badge--${variant}`,
    size && `status-badge--${size}`,
    rounded && 'status-badge--rounded',
    outline && 'status-badge--outline',
    minimal && 'status-badge--minimal',
    className
  ].filter(Boolean).join(' ');

  const content = htmlContent ? (
    <span dangerouslySetInnerHTML={{ __html: htmlContent }} />
  ) : (
    children
  );

  // badgeColor e fontColor só são aplicados se passados via props
  const customStyle = {
    ...(badgeColor ? { backgroundColor: badgeColor, borderColor: badgeColor } : {}),
    ...(fontColor ? { color: fontColor } : {}),
    ...props.style,
  };

  return (
    <span className="status-badge-component">
      <span className={badgeClasses} style={customStyle} {...props}>
        {icon && <span className="status-badge__icon">{icon}</span>}
        <span className="status-badge__content">{content}</span>
      </span>
    </span>
  );
};

export default StatusBadge;
